import React, { PureComponent } from 'react';
import { string, func, number, bool } from 'prop-types';
import classnames from 'classnames';

export default class PaginationItem extends PureComponent {
    static propTypes = {
        target: number.isRequired,
        onClick: func.isRequired,
        label: string.isRequired,
        className: string,
        dataQa: string.isRequired,
        active: bool,
        rel: string,
        url: string.isRequired,
    };

    static defaultProps = {
        active: false,
        className: null,
        rel: null,
    };

    handleClick = evt => {
        evt.preventDefault();
        const { onClick, target } = this.props;
        onClick(target, evt);
    };

    render() {
        const { label, className, dataQa, active, rel, url } = this.props;
        const classname = classnames('pagination__item', className, {
            'pagination__item--active': active,
        });

        return (
            <li className={classname}>
                {active ? (
                    <span className="pagination__item__link">{label}</span>
                ) : (
                    <a
                        href={url}
                        className="pagination__item__link"
                        onClick={this.handleClick}
                        data-qa={dataQa}
                        rel={rel}
                    >
                        {label}
                    </a>
                )}
            </li>
        );
    }
}
